export const ACCESS_NATIVE_APP_ID = 1;
export const MAILROOM_NATIVE_APP_ID = 2;
export const PROTECT_NATIVE_APP_ID = 3;
export const VIDEO_NATIVE_APP_ID = 4;
export const SOS_NATIVE_APP_ID = 5;
export const VISITOR_NATIVE_APP_ID = 6;
export const WEAR_NATIVE_APP_ID = 9;

// We have this all defined in 2 places. We should consolidate
export enum NativeAppStatus {
  Active = 'A',
  Inactive = 'I',
  Pending = 'P',
  Error = 'E',
  SettingUp = 'S',
}
